var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$locale && _vm.$locale.landing)?_c('section',{staticClass:"home-section"},[_c('Header'),_c('Landing'),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }